export default {
  请先选择一个部门: "請先選擇一個部門",
  选择部门: "選擇部門",
  请输入部门名称: "請輸入部門名稱",
};
